import i18n from '../../../../../resources/js/Vuei18n';

i18n.mergeLocaleMessage('ca', require('../../lang/ca.json'))
i18n.mergeLocaleMessage('es', require('../../lang/es.json'))
i18n.mergeLocaleMessage('en', require('../../lang/en.json'))